<template>
  <v-dialog
    :style="{'z-index':zIndexWkStnDialog}"
    v-model="dialog"
    persistent max-width="30vw"
  >
    <v-card ref="inputDialogForWorkstationId">
      <v-card-title>Please Enter Workstation ID</v-card-title>
      <v-divider></v-divider>
      <v-card-text class="mt-2">
        <v-form ref="form">
          <v-text-field
            class="workstation-id-text-field"
            id="workstationIdTextField"
            v-model="wkst"
            :rules="wkstValidation"
            hint="please enter numbers only"
          >
          </v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="workstation-id-submit-btn"
            id="workstationIdSubmitBtn"
            color="primary"
            text
            @click="setWkst"
          >
            Save
          </v-btn>
        </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import { setWorkstationNumber, getWorkstationNumber } from '../../util/workstation-util';
import { checkStringEmptiness } from '../../util/shared/vue-global';
import { TMC_CONSTANTS } from '../../util/shared/constants';
import { getRawJwt, parseJwt } from '../../util/jwt';

// The workstation number is carried in the JWT (`wkst` claim) and the backend attaches scanned
// images by that claim alone. A token minted before this dialog was answered has no workstation,
// so keeping it would leave the session unable to attach scans ("There was a problem on uploading
// files") until the next sign-in.
export const tokenWkst = () => {
  const rawJwt = getRawJwt();
  if (!rawJwt) {
    return undefined;
  }
  try {
    const { wkst } = parseJwt(rawJwt);
    return String(wkst === undefined || wkst === null ? '' : wkst).trim() || undefined;
  } catch (e) {
    console.warn('unable to read the workstation number from the current token');
    return undefined;
  }
};

export default {
  name: 'InputDialogForWorkstationId',
  data: () => ({
    wkst: undefined,
    zIndexWkStnDialog: TMC_CONSTANTS.COMPONENT_Z_INDEX.WKST_DIALOG,
  }),
  created() {
    this.checkOrInputWkst();
    this.fetchAndSetWkst({});
  },
  computed: {
    ...mapState({
      wkstDialog: (state) => state.wkstDialog,
    }),
    dialog: {
      get() {
        return this.wkstDialog;
      },
      set(value) {
        this.setWkstDialog(value);
      },
    },
    wkstValidation() {
      return [
        (value) => /^(?!0+$)\d+$/.test(value) || 'Please enter numbers > 0 only',
        (value) => Number(value) <= 999 || 'Workstation ID must be 999 or less',
      ];
    },
  },
  methods: {
    ...mapMutations(['setWkstDialog']),
    ...mapActions(['flashSuccess']),
    ...mapActions('SystemConfig', [
      'fetchAndSetWkst',
    ]),
    ...mapMutations('auth/token', [
      'setLoggedOut',
    ]),
    checkOrInputWkst() {
      setWorkstationNumber(window);
      const wkstNumber = getWorkstationNumber();
      const isWkstNumeric = /^(?!0+$)\d+$/.test(wkstNumber);
      if (checkStringEmptiness(wkstNumber) || !isWkstNumeric) {
        this.dialog = true;
      }
    },
    setWkst() {
      if (this.$refs.form.validate()) {
        /* the signed-in token still carries the old (or no) workstation — it has to be re-minted */
        const staleToken = getRawJwt() && tokenWkst() !== String(this.wkst);
        setWorkstationNumber(window, this.wkst);
        this.flashSuccess(staleToken
          ? 'Workstation ID Successfully Saved, please sign in again'
          : 'Workstation ID Successfully Saved');
        this.dialog = false;
        this.fetchAndSetWkst({});
        if (staleToken) {
          this.$nextTick(() => {
            this.setLoggedOut();
          });
        }
      }
    },
  },
};
</script>

<style>

</style>
